import React, { ReactElement, useEffect, useState } from "react";
import styles from "./TimetableList.module.scss";
import { IEvent, IEventInfo } from "@common/redux/types/event";
import { TimetableBlock } from "@kursk/components/ui/TimetableBlock/TimetableBlock";
import { DateFilter } from "@kursk/components/ui/DateFilter/DateFilter";
import moment from "moment";
import _ from "lodash";
import classNames from "classnames";

interface IProp {
  data: IEventInfo[];
  event: IEvent;
  forRef: any;
  withDateFilter?: boolean;
  isIframe?: boolean;
}

const getSortedDates = (data: any[]) => [...data].sort((a, b) => a.start - b.start);

export const TimetableList = ({ data, event, forRef, withDateFilter, isIframe }: IProp): ReactElement => {
  if (!data || data.length === 0) {
    return <></>;
  }

  // Хак - sort меняет данные в массиве, а data приходит к нам в режиме read-only
  const allDates = getSortedDates(data);

  const showDateFilter = allDates.length > (isIframe ? 50 : 3);

  const [filteredDates, setFilteredDates] = useState(allDates);
  useEffect(() => {
    setFilteredDates(getSortedDates(data));
  }, [data]);

  const [rangeStart, setRangeStart] = useState(null);
  const [rangeEnd, setRangeEnd] = useState(null);

  let keysActiveDays: number[];
  let dateStart: moment.Moment;
  let daysLong: number;
  if (showDateFilter) {
    keysActiveDays = Object.keys(event?.schedulesActiveDays).map((i) => Number(i)).sort((a, b) => a - b);
    dateStart = (() => {
      if (event.type === 'schedules') {
        return moment(+allDates[0].periodStart).isAfter(moment()) ? moment(+allDates[0].periodStart) : moment();
      }
      if (event.type === 'seances') {
        return moment(+keysActiveDays[0]);
      }
      return moment();
    })();
    const dateEnd = moment(+keysActiveDays[keysActiveDays.length - 1]);
    daysLong = Math.ceil(Math.abs(+dateEnd - +dateStart) / (1000 * 3600 * 24));
  }

  const itemsPerPage = 3;
  const [currentPagination, setCurrentPagination] = useState(itemsPerPage);
  const [isShowMore, setIsShowMore] = useState(!!filteredDates[currentPagination]);

  useEffect(() => {
    setIsShowMore(!!filteredDates[currentPagination]);
  }, [filteredDates, currentPagination]);

  const isScheduleInRange = (schedule: IEventInfo, start: number, end?: number): boolean => {
    if (start && !end) {
      return Boolean(schedule.activeDays.find((day) =>
        +moment(day.start).startOf('day') === +moment(start).startOf('day')));
    }
    if (start && end) {
      for (let startTemp = start; startTemp <= end; startTemp = +moment(startTemp).add(1, 'day')) {
        if (schedule.activeDays.find((day) =>
          +moment(day.start).startOf('day') === +moment(startTemp).startOf('day') ||
          +moment(day.start).startOf('day') === +moment(end).startOf('day'))) {
          return true;
        }
      }
      return false;
    }
  }

  const onDateChange = ({ start, end }) => {
    setCurrentPagination(itemsPerPage);
    if (start) {
      setRangeStart(start);
    } else {
      setRangeStart(null);
    }
    if (end) {
      setRangeEnd(end);
    } else {
      setRangeEnd(null);
    }
    const filteredArray = allDates
      .filter((date) => isScheduleInRange(date, start, end));
    if (!start && !end) {
      setFilteredDates(allDates);
    } else {
      setFilteredDates(_.uniq(filteredArray));
    }
  };
  const showMore = () => {
    setCurrentPagination(currentPagination + 3);
  };

  return (
    <div className={classNames(styles.event_timetables__wrapper, { [styles.isIframe]: isIframe })}>
      {!isIframe &&
        <div className={styles.event_timetables__title} ref={forRef}>Расписание</div>
      }
      {(withDateFilter && showDateFilter) && (
        <div className={styles.event_timetables__dateFilter}>
          <DateFilter
            noBorder
            leftDatesDefault={0}
            rightDatesDefault={daysLong}
            dateStart={dateStart}
            onChange={onDateChange}
            filters={{
              start: rangeStart,
              end: rangeEnd
            }}
            enableDates={keysActiveDays}
            withoutInterim
            isOpenMobileCarousel
          />
        </div>
      )}
      {
        filteredDates.slice(0, currentPagination).map((item: IEventInfo, index: number) => {
          return (
            <TimetableBlock
              mode={'schedule'}
              key={item.start + item.end + index}
              index={index}
              info={item}
              event={event}
              defaultDate={item.start}
              showBuyButton={item.showBuyButton}
              isIframe={isIframe}
            />
          )
        })
      }
      {
        isShowMore &&
        <div className={styles.event_timetables__showMore}>
          <div className={styles.event_timetables__showMoreTitle} onClick={() => showMore()}>
            ПОСМОТРЕТЬ ЕЩЁ
          </div>
        </div>
      }
    </div>
  )
}
